import { Component, OnInit, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-day-move-buttons',
    templateUrl: './day-move-buttons.component.html',
    styleUrls: ['./day-move-buttons.component.scss'],
    standalone: false
})
export class DayMoveButtonsComponent implements OnInit {
    @Output() previous = new EventEmitter<void>();
    @Output() today = new EventEmitter<void>();
    @Output() next = new EventEmitter<void>();

    constructor() { }

    ngOnInit(): void {
    }

    handlePrevious(): void {
        this.previous.emit();
    }

    handleToday(): void {
        this.today.emit();
    }

    handleNext(): void {
        this.next.emit();
    }
}
